import { useMemo } from 'react';
import { TABS } from '../constants/tabs';
const parentRenderedFeatures = [TABS.APPROVALS, TABS.CAMPAIGN_SPECIALIST];
export function useIsTabParentRendered(tab) {
  return useMemo(() => {
    return parentRenderedFeatures.includes(tab);
  }, [tab]);
}